/*
 *
 * Pickups reducer
 *
 */

import * as actions from "./constants";

export const initialState = {
  data: undefined,
  pending: false,
  complete: false,
  pickupStatuses: undefined,
};

function pickupsReducer(state = initialState, action) {
  const { rehydrating } = action;
  switch (action.type) {
    case actions.PICKUPS_FETCH:
      return { ...state, pending: true, complete: false, rehydrating };

    case actions.PICKUPS_FETCH_SUCCESS:
      return {
        ...state,
        data: action.data,
        pickupStatuses: action.meta,
        pending: false,
        complete: true,
        rehydrating: false,
      };

    case actions.PICKUPS_OUTDATED:
      return { ...state, pending: false, complete: false, rehydrating: false };

    default:
      return state;
  }
}

export default pickupsReducer;
